import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

interface AuthContextType {
  isLoggedIn: boolean;
  userEmail: string | null;
  login: (email: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => {
    return localStorage.getItem('famini-auth') === 'true';
  });

  const [userEmail, setUserEmail] = useState<string | null>(() => {
    return localStorage.getItem('famini-user-email');
  });

  useEffect(() => {
    localStorage.setItem('famini-auth', String(isLoggedIn));
    if (userEmail) {
      localStorage.setItem('famini-user-email', userEmail);
    } else {
      localStorage.removeItem('famini-user-email');
    }
  }, [isLoggedIn, userEmail]);

  const login = useCallback((email: string) => {
    setIsLoggedIn(true);
    setUserEmail(email);
  }, []);

  const logout = useCallback(() => {
    setIsLoggedIn(false);
    setUserEmail(null);
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, userEmail, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
